"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ImageBannerPreviewer;
const react_1 = __importStar(require("react"));
const ImageBannerPreviewer_module_scss_1 = __importDefault(require("./ImageBannerPreviewer.module.scss"));
const SharedImageBanner_1 = __importDefault(require("../../SharedImageBanner/SharedImageBanner"));
const SharedPremiumImageBanner_1 = __importDefault(require("../../SharedPremiumImageBanner/SharedPremiumImageBanner"));
function ImageBannerPreviewer(props) {
    const [previewerSize, setPreviewerSize] = (0, react_1.useState)("desktop");
    const isPremium = props.designType === "premiumSmallImage";
    return (react_1.default.createElement("div", { className: ImageBannerPreviewer_module_scss_1.default.previewerContainer, "data-testid": "image-banner-previewer" },
        react_1.default.createElement("div", { className: ImageBannerPreviewer_module_scss_1.default.optionsContainer },
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", { htmlFor: "previewer-size" }, "Device type: "),
                react_1.default.createElement("select", { id: "previewer-size", defaultValue: "desktop", onChange: (e) => setPreviewerSize(e.target.value) },
                    react_1.default.createElement("option", { value: "desktop" }, "Desktop"),
                    react_1.default.createElement("option", { value: "tablet" }, "Tablet"),
                    react_1.default.createElement("option", { value: "mobile" }, "Mobile")))),
        react_1.default.createElement("div", { className: ImageBannerPreviewer_module_scss_1.default[previewerSize], "data-testid": "image-banner-preview-container" }, isPremium ? (react_1.default.createElement(SharedPremiumImageBanner_1.default, Object.assign({}, props, { previewerSize: previewerSize }))) : (react_1.default.createElement(SharedImageBanner_1.default, Object.assign({}, props, { previewerSize: previewerSize }))))));
}
